import { createTheme } from 'design-system';
import { createTheme as createMuiTheme } from '@material-ui/core/styles';

const refTheme = createTheme();
const modifiedTheme: ReturnType<typeof createTheme> = {
  ...createMuiTheme({
    ...refTheme,
    typography: {
      fontFamily: ['Noto Sans SC', 'sans-serif'].join(','),
    },
  }),
};

export default modifiedTheme;
